import { useEffect } from "react";
import gsap from "gsap";

export const useButtonRipples = () => {
  useEffect(() => {
    const onDown = (e) => {
      const btn = e.target.closest("button, a[class*='rounded-full']");
      if (!btn || btn.disabled) return;
      const r = btn.getBoundingClientRect();
      const size = Math.max(r.width, r.height) * 1.6;
      const span = document.createElement("span");
      span.className = "btn-ripple";
      span.style.width = span.style.height = `${size}px`;
      span.style.left = `${e.clientX - r.left}px`;
      span.style.top = `${e.clientY - r.top}px`;
      const prevOverflow = btn.style.overflow;
      btn.style.overflow = "hidden";
      btn.appendChild(span);
      gsap.fromTo(span, { scale: 0, opacity: 0.9 }, { scale: 1, opacity: 0, duration: 0.65, ease: "power2.out", onComplete: () => { span.remove(); btn.style.overflow = prevOverflow; } });
      gsap.fromTo(btn, { scale: 0.96 }, { scale: 1, duration: 0.5, ease: "elastic.out(1, 0.5)", clearProps: "scale" });
    };
    document.addEventListener("pointerdown", onDown, { passive: true });
    return () => document.removeEventListener("pointerdown", onDown);
  }, []);
};
